import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer
} from "recharts";

const data = [
    { name: "Lun", value: 1200 },
    { name: "Mar", value: 2100 },
    { name: "Mer", value: 1800 },
    { name: "Jeu", value: 2600 },
    { name: "Ven", value: 2000 },
    { name: "Sam", value: 3100 },
    { name: "Dim", value: 2800 }
];

export default function Chart() {
    return (
        <div className="card">
            <div className="card-header">
                <span className="card-title">Revenus de la semaine</span>
            </div>

            <div style={{ width: "100%", height: 250 }}>
                <ResponsiveContainer>
                    <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e3e7f0" />
                        <XAxis dataKey="name" stroke="#98e3da" />
                        <YAxis stroke="#98e3da" />
                        <Tooltip />
                        <Line
                            type="monotone"
                            dataKey="value"
                            stroke="#98e3da"
                            strokeWidth={3}
                            dot={{ r: 4 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
